import fp from 'lodash/fp';
import queryString from 'query-string';
import { push } from 'react-router-redux';
import { all, put, select, takeLatest } from 'redux-saga/effects';
import { questionType, routes } from '../../../../constants';
import { apiActionResult } from '../../common';
import { authTokenSelector } from '../../session';
import actions, { apiActions } from './actions';

export function* getContent(action) {
  const authToken = yield select(authTokenSelector);
  yield put(apiActions.publisherPortal.content.get(authToken, action.payload.skip, action.payload && action.payload.query));
}

export function* getContentById(action) {
  const authToken = yield select(authTokenSelector);
  yield put(apiActions.publisherPortal.content.getById(authToken, action.payload.contentId));
}

export function* saveContent(action) {
  const { content, nextRoute } = action.payload;
  const authToken = yield select(authTokenSelector);
  const apiAction = fp.has('payload.content.contentData.content')(action) && content.contentData.content.id ?
    'updateContent' :
    'addContent';
  const contentFormData = {
    data: content.contentData,
    file: content.files
  };

  yield put(fp.get(apiAction, apiActions.publisherPortal.content)(authToken, contentFormData));

  const { success } = yield apiActionResult(fp.get(apiAction, actions.publisherPortal.content.api));

  if (success && nextRoute) {
    const nextLocation = nextRoute.contentIdParam ?
      {
        ...nextRoute,
        search: `?${queryString.stringify({ contentId: success.payload.content.id })}`
      } :
      nextRoute;

    yield put(push(nextLocation));
  }
}

export function* loadMoreContents(action) {
  const authToken = yield select(authTokenSelector);
  yield put(apiActions.publisherPortal.content.loadMore(authToken, action.payload.skip, action.payload.query));
}

export function* getContentQuestions(action) {
  const authToken = yield select(authTokenSelector);
  yield put(apiActions.publisherPortal.content.getContentQuestions(authToken, action.payload.contentId));
}

export function* saveQuestion(action) {
  const authToken = yield select(authTokenSelector);
  const { questionData } = action.payload;
  let answers = [];

  if (questionData.questionType === questionType.MultiChoice) {
    answers = fp.filter((a) => a.description && a.description.trim() !== '')(questionData.multiAnswers);
  }

  if (questionData.questionType === questionType.ShortAnswer) {
    answers = [Object.assign({}, questionData.shortAnswer, { isCorrect: true })];
  }

  if (questionData.questionType === questionType.NumericAnswer) {
    answers = [Object.assign({}, questionData.numericAnswer, { isCorrect: true })];
  }

  const contentQuiz = {
    question: {
      id: questionData.id,
      description: questionData.description,
      questionType: questionData.questionType,
      imageFileName: questionData.questionImageName,
      metaData: questionData.metaData
    },
    answers: answers
  };

  const contentQuizFormData = {
    data: contentQuiz,
    file: questionData.questionImage
  }

  if (contentQuiz.question.id) {
    yield put(apiActions.publisherPortal.content.updateQuestion(authToken, questionData.contentId, contentQuiz.question.id, contentQuizFormData));
  }
  else {
    yield put(apiActions.publisherPortal.content.addQuestion(authToken, questionData.contentId, contentQuizFormData));
  }
}

export function* deleteQuestion(action) {
  const authToken = yield select(authTokenSelector);
  const { contentId, questionId } = action.payload;
  yield put(apiActions.publisherPortal.content.deleteQuestion(authToken, contentId, questionId));
}

export function* deleteContent(action) {
  const authToken = yield select(authTokenSelector);
  const { contentId, contentQuery } = action.payload;

  yield put(apiActions.publisherPortal.content.deleteContent(authToken, contentId));

  const { success } = yield apiActionResult(actions.publisherPortal.content.api.deleteContent);

  if (success) {
    if (contentQuery) {
      yield put(actions.publisherPortal.content.get(0, contentQuery));
    }
    yield put(push({ pathname: routes.publisherPortal.content }));
  }
}

export function* getContentPassedUserEmails(action) {
  const authToken = yield select(authTokenSelector);
  yield put(apiActions.publisherPortal.content.getContentPassedUserEmails(authToken, action.payload.contentId));
}

export const sagas = all([
  takeLatest(actions.publisherPortal.content.get().type, getContent),
  takeLatest(actions.publisherPortal.content.getById().type, getContentById),
  takeLatest(actions.publisherPortal.content.saveContent().type, saveContent),
  takeLatest(actions.publisherPortal.content.loadMore().type, loadMoreContents),
  takeLatest(actions.publisherPortal.content.saveQuestion().type, saveQuestion),
  takeLatest(actions.publisherPortal.content.deleteQuestion().type, deleteQuestion),
  takeLatest(actions.publisherPortal.content.getContentQuestions().type, getContentQuestions),
  takeLatest(actions.publisherPortal.content.deleteContent().type, deleteContent),
  takeLatest(actions.publisherPortal.content.getContentPassedUserEmails().type, getContentPassedUserEmails)
]);

function* contentSagas() {
  yield sagas;
}

export default contentSagas;



// WEBPACK FOOTER //
// ./src/state/modules/publisher-portal/content/sagas.js